<div class="profile-social-links-container">
  @if (isLoading()) {
  <multisite-loader-globe-animation-detail>
  </multisite-loader-globe-animation-detail>
  } @else {
  <div class="social-links-content">

    <!-- Current Social Links List -->
    @if (socialLinks().length > 0) {
    <div class="current-links-section">
      <h3>{{ 'profile.my_social_media' | transloco }}</h3>
      <div class="links-list">
        @for (link of socialLinks(); track link.id) {
        <div
          class="link-item"
          [class.editing]="editingLinkId() === link.id"
        >
          @if (editingLinkId() !== link.id) {
          <div class="link-display">
            <div class="link-header">
              <span class="channel-label">{{ getChannelLabelForLink(link) }}</span>
              <div class="link-actions">
                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary"
                  (click)="onEditLink(link)"
                  [disabled]="isAnythingLoading()"
                >
                  {{ 'common.edit' | transloco }}
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-danger"
                  (click)="onDeleteLink(link.id)"
                  [disabled]="isAnythingLoading()"
                >
                  {{ 'common.delete' | transloco }}
                </button>
              </div>
            </div>
            <div class="link-body">
              <p class="link-url"><a
                  [href]="link.url"
                  target="_blank"
                  rel="noopener"
                >{{ link.url }}</a></p>
              @if (link.label) {
              <p class="link-label">{{ link.label }}</p>
              }
              @if (link.description) {
              <p class="link-description">{{ link.description }}</p>
              }
            </div>
          </div>
          }

          @if (editingLinkId() === link.id) {
          <div class="link-edit-form">
            <form [formGroup]="editLinkForm">
              <div class="form-group">
                <label for="edit-url">{{ 'content_management.web_address' | transloco }} *</label>
                <input
                  id="edit-url"
                  type="url"
                  class="form-control"
                  formControlName="url"
                  [disabled]="formDisabled()"
                />
                <cco-common-form-validation-messages
                  class="mt-2"
                  [control]="editLinkForm.get('url')"
                  [showErrors]="submitAttempted()"
                ></cco-common-form-validation-messages>
              </div>

              <div class="form-group">
                <label for="edit-label">{{ 'content_management.title' | transloco }}</label>
                <input
                  id="edit-label"
                  type="text"
                  class="form-control"
                  formControlName="label"
                  [disabled]="formDisabled()"
                />
                <cco-common-form-validation-messages
                  class="mt-2"
                  [control]="editLinkForm.get('label')"
                  [showErrors]="submitAttempted()"
                ></cco-common-form-validation-messages>
              </div>

              <div class="form-group">
                <label for="edit-description">{{ 'common.description' | transloco }}</label>
                <textarea
                  id="edit-description"
                  class="form-control"
                  formControlName="description"
                  rows="3"
                  [disabled]="formDisabled()"
                ></textarea>
                <cco-common-form-validation-messages
                  class="mt-2"
                  [control]="editLinkForm.get('description')"
                  [showErrors]="submitAttempted()"
                ></cco-common-form-validation-messages>
              </div>

              <div class="form-actions">
                <button
                  type="button"
                  class="btn btn-primary"
                  (click)="onSaveEdit()"
                  [disabled]="formDisabled() || !editLinkForm.valid"
                >
                  {{ 'common.save' | transloco }}
                </button>
                <button
                  type="button"
                  class="btn btn-secondary"
                  (click)="onCancelEdit()"
                  [disabled]="formDisabled()"
                >
                  {{ 'common.cancel' | transloco }}
                </button>
              </div>
            </form>
          </div>
          }
        </div>
        }
      </div>
    </div>
    } @else {
    <div class="empty-state">
      <p *transloco="let t">{{t('common.none_yet')}}</p>
    </div>
    }

    <!-- Add New Social Link Section -->
    <div class="add-link-section mb-1">
      <!-- <h3>{{ 'profile.social.add_link' | transloco }}</h3> -->

      <div class="channel-selector">
        <p class="selector-label">
          <span *transloco="let t; scope:'profile'">{{t('profile.add_social_channel')}}</span>
        </p>
        <div class="channel-grid">
          @for (template of availableChannels(); track template.type) {
          <button
            type="button"
            class="channel-option"
            (click)="onSelectChannel(template.type)"
            [disabled]="formDisabled()"
          >
            <i [class]="template.icon"></i>
            <span>{{ template.label }}</span>
          </button>
          }
        </div>
        @if (availableChannels().length === 0) {
        <p class="text-muted">
          {{ 'profile.social.all_channels_added' | transloco }}
        </p>
        }
      </div>

      @if (newLinkForm.get('type')?.value) {
      <form [formGroup]="newLinkForm">
        <div class="form-group">
          <!-- <label>{{ 'profile.social.selected_channel' | transloco }}:</label> -->
          <p class="selected-channel-display">{{ getSelectedChannelLabel() }}</p>
        </div>

        <div class="form-group">
          <label for="new-url">{{ 'content_management.web_address' | transloco }} *</label>
          <input
            id="new-url"
            type="url"
            class="form-control"
            formControlName="url"
            [disabled]="formDisabled()"
            [placeholder]="
              socialChannelTemplates.find((t) => t.type === newLinkForm.get('type')?.value)?.placeholder || ''
            "
          />
          <cco-common-form-validation-messages
            class="mt-2"
            [control]="newLinkForm.get('url')"
            [showErrors]="submitAttempted()"
          ></cco-common-form-validation-messages>
        </div>

        <div class="form-group">
          <label for="new-label">{{ 'content_management.title' | transloco }}</label>
          <input
            id="new-label"
            type="text"
            class="form-control"
            [placeholder]="'profile.social_link_name_example' | transloco"
            formControlName="label"
            [disabled]="formDisabled()"
          />
          <cco-common-form-validation-messages
            class="mt-2"
            [control]="newLinkForm.get('label')"
            [showErrors]="submitAttempted()"
          ></cco-common-form-validation-messages>
        </div>

        <div class="form-group">
          <label for="new-description">{{ 'common.description' | transloco }}</label>
          <textarea
            id="new-description"
            class="form-control"
            formControlName="description"
            rows="3"
            [disabled]="formDisabled()"
          ></textarea>
          <cco-common-form-validation-messages
            class="mt-2"
            [control]="newLinkForm.get('description')"
            [showErrors]="submitAttempted()"
          ></cco-common-form-validation-messages>
        </div>

        <div class="form-actions">
          <button
            type="button"
            class="btn btn-primary"
            (click)="onAddLink()"
            [disabled]="formDisabled() || !newLinkForm.valid"
          >
            {{ 'common.add' | transloco }}
          </button>
        </div>
      </form>
      }
    </div>
    @if (error()) {
      <div class="alert alert-danger" role="alert">
        <strong>{{ 'common.error' | transloco }}:</strong> {{ error() | transloco }}
      </div>
    }

  </div>
  }
</div>